const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080';

/**
 * Aus einer gespeicherten Bildadresse die Adresse machen, die der Browser laden kann.
 *
 * Beiträge kennen zwei Sorten von Bildern, und beide stehen als schlichte Adresse
 * im Datensatz:
 * - `/website/img/news/…` — der Bestand, ausgeliefert als Datei vom selben Server
 *   wie die Website. Bleibt unverändert.
 * - `/api/public/news-images/12` — nachträglich hochgeladen, liegt in der Datenbank
 *   und kommt damit vom **Backend**, das unter einer eigenen Adresse läuft. Ohne
 *   das Voranstellen der API-Adresse suchte der Browser das Bild auf dem
 *   Website-Server und fände dort nichts.
 *
 * Absolute Adressen bleiben unangetastet — auch die, die `usePageMeta` für
 * Social-Vorschauen bildet.
 */
export function mediaUrl(src: string): string {
  if (!src) return src;
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  if (src.startsWith('/api/')) return `${API_BASE_URL}${src}`;
  return src;
}

export default mediaUrl;
